// extracted by mini-css-extract-plugin
module.exports = {"root":"Automation_root__219Nd","allowManagement":"Automation_allowManagement__3k7pI","statusLabel":"Automation_statusLabel__2YyGb"};